var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.682461 15.8081C0.681711 18.4967 1.38971 21.1219 2.73596 23.4359L0.553711 31.3418L8.70771 29.2204C10.963 30.4387 13.4899 31.077 16.0577 31.0772H16.0645C24.5413 31.0772 31.4417 24.2327 31.4453 15.8201C31.447 11.7436 29.8485 7.91027 26.9442 5.0263C24.0405 2.14258 20.1786 0.553618 16.0638 0.551758C7.58596 0.551758 0.686086 7.39579 0.682586 15.8081",
    fill: "url(#paint0_linear_1078_360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13375 15.8035C0.132875 18.5889 0.86625 21.308 2.2605 23.7048L0 31.8942L8.44637 29.6967C10.7736 30.9558 13.3939 31.6196 16.0601 31.6206H16.067C24.848 31.6206 31.9963 24.53 32 15.8162C32.0015 11.5932 30.3455 7.62208 27.3375 4.63479C24.3291 1.64788 20.3291 0.00173643 16.067 0C7.2845 0 0.137375 7.08961 0.133875 15.8035H0.13375ZM5.16375 23.292L4.84837 22.7953C3.52262 20.7036 2.82287 18.2865 2.82387 15.8045C2.82675 8.56174 8.76725 2.66915 16.072 2.66915C19.6095 2.67064 22.934 4.03895 25.4345 6.52155C27.9349 9.0044 29.3108 12.3049 29.3099 15.8152C29.3066 23.058 23.366 28.9513 16.067 28.9513H16.0618C13.6851 28.9501 11.3542 28.3168 9.3215 27.12L8.83775 26.8354L3.8255 28.1393L5.16375 23.2919V23.292Z",
    fill: "url(#paint1_linear_1078_360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0845 9.19662C11.7862 8.53888 11.4723 8.52561 11.1887 8.51407C10.9565 8.50415 10.691 8.5049 10.4257 8.5049C10.1602 8.5049 9.72883 8.604 9.3642 8.99904C8.9992 9.39445 7.9707 10.35 7.9707 12.2934C7.9707 14.237 9.39733 16.1152 9.5962 16.379C9.79533 16.6423 12.3503 20.7582 16.3968 22.3415C19.7598 23.6574 20.4442 23.3957 21.1741 23.3297C21.9041 23.264 23.5296 22.3744 23.8612 21.452C24.1931 20.5297 24.1931 19.7391 24.0936 19.5739C23.9941 19.4093 23.7286 19.3105 23.3305 19.113C22.9322 18.9154 20.975 17.9598 20.6101 17.8279C20.2451 17.6962 19.9797 17.6305 19.7142 18.026C19.4487 18.4209 18.6863 19.3105 18.454 19.5739C18.2218 19.838 17.9895 19.8708 17.5915 19.6733C17.1931 19.4751 15.911 19.0584 14.3898 17.7128C13.2063 16.6658 12.4073 15.3727 12.1751 14.9772C11.9428 14.5823 12.1502 14.3682 12.3498 14.1714C12.5287 13.9944 12.7481 13.7101 12.9473 13.4795C13.1458 13.2488 13.2121 13.0842 13.3448 12.8208C13.4777 12.5571 13.4112 12.3264 13.3118 12.1288C13.2121 11.9313 12.4385 9.97776 12.0845 9.19674",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1078_360",
    x1: 15.9995,
    y1: 31.3418,
    x2: 15.9995,
    y2: 0.551758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1078_360",
    x1: 16,
    y1: 31.8942,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ca9a06b8800342222b8c961f3ee2becc.svg";
export { ForwardRef as ReactComponent };